<script setup lang="ts">
import { AllTimezones } from '@/types/shared/timezones'

const selectedTz = defineModel<string>()
if (!selectedTz.value) {
  selectedTz.value = 'US/Central'
}
</script>

<template>
  <el-select v-model="selectedTz" filterable default-first-option>
    <el-option v-for="tz in AllTimezones" :key="tz" :label="tz" :value="tz" />
  </el-select>
</template>
